import React from "react";
import { CurrencyDisplayProps, DisplayProps } from "models/propTypes/wintFormPropsTypes";
import { LocalizationHelperInstance } from "utils/helpers";
import ReadOnlyField from "../../forms/baseFields/readOnlyField";
import cssExports from "theme/styles/main.module.scss";

const CurrencyDisplay: React.FC<DisplayProps> = (props: CurrencyDisplayProps) => {
  return (
    <ReadOnlyField label={props.label} className={cssExports.readOnlyTextField}>
      {LocalizationHelperInstance.getFormattedCurrency(+props.value, props.currency, 2, 2, props.currencyDisplay)}
    </ReadOnlyField>
  );
};

export default CurrencyDisplay;
